import { ExpandMoreRounded } from "@mui/icons-material";
import { Typography, AccordionDetails, AccordionSummary, Accordion } from "@mui/material";
import { FC, useState } from "react"
import { useTranslation } from "react-i18next";
import { IBookingDetails} from "../page/contract/ContractInterfaces";
import BookingAndRaTable from "./BookingAndRaTable";

const BookingAndRaDetails:FC <{data: IBookingDetails[], showTypographyInnerTable?: boolean}> =
    ({data,showTypographyInnerTable = false}) => {
    const [expanded,setExpanded] = useState(false);
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'bookingAndRa'});
    return <>
        <Accordion
            expanded={expanded}
            onChange={() => setExpanded((prev: boolean) => !prev)}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreRounded/>}
                aria-controls="subperiods-content"
                id="superiods-header"
            >
                <Typography>{t('title')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {data && data.length > 0 &&
                    <BookingAndRaTable data={data} showTypography={showTypographyInnerTable}/>
                }
            </AccordionDetails>
        </Accordion>
    </> 
}



export default BookingAndRaDetails;